import type { components } from "@medimo/core-api/internal/openapi";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

type Consult = components["schemas"]["ConsultReadModel"];
type ConsultLog = components["schemas"]["ConsultLogReadModel"];
type ConsultConsultLog = {
  consult?: Partial<Consult>;
  consultLog?: Partial<ConsultLog>;
};

type UseGlobalConsultConsultLog = {
  consults: Record<string, ConsultConsultLog>;
  add: (consultId: string, data: ConsultConsultLog) => void;
  remove: (consultId: string) => void;
  removeAll: () => void;
};

const empty_object = {};

export const useGlobalConsultsOnLocalStore =
  create<UseGlobalConsultConsultLog>()(
    devtools(
      persist(
        immer((set) => ({
          consults: {},
          add(consultId, data) {
            set((state) => {
              state.consults[consultId] = data;
            });
          },
          remove(consultId) {
            set((state) => {
              delete state.consults[consultId];
            });
          },
          removeAll() {
            set((state) => {
              state.consults = empty_object;
            });
          },
        })),
        {
          name: "medimo-consults-store",
          version: 1,
        },
      ),
    ),
  );
